/*eslint-disable*/
import React, { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { getCookie } from '../../Utils';
import { Tooltip } from 'reactstrap';

import './upvote.scss';

/*
    upvoteHandler: function to handle upvote
    roadmap: roadmap object
    roadmapDetails: boolean -> to increase height of upvote component in roadmap details page.
*/
const UpvoteComponent = ({
    upvoteHandler,
    roadmap,
    roadmapDetails,
    upvoteType
}) => {
    const { upvotes, upvoters } = roadmap || {};
    const userEmail = getCookie('pl.authEmail');

    const [showTooltip, setShowTooltip] = useState(false);
    const [hasUserUpvoted, setHasUserUpvoted] = useState(upvoters?.some(upvoter => upvoter.email === userEmail));

    const toggle = () => setShowTooltip(!showTooltip);

    const clickHandler = (event) => {
        event.stopPropagation();
        if (hasUserUpvoted) {
            setShowTooltip(true);
            const timer = setTimeout(() => {
                setShowTooltip(false);
            }, 3000); // Hide tooltip after 3 seconds
            return () => clearTimeout(timer);
        }
        // if function is passed.
        if (upvoteHandler) {
            upvoteHandler(roadmap, roadmapDetails && 'details');
        }
    };

    useEffect(() => {
        setHasUserUpvoted(upvoters?.some(upvoter => upvoter.email === userEmail));
    }, [upvoters, userEmail]);

    return (
        <div
            className={`upvotes upvote-component 
                ${hasUserUpvoted && 'upvoted'} 
                ${upvoteType === "pending-feedback" && "pending-feedback-upvote"}
                ${roadmapDetails && 'upvote-details'} 
                ${!upvoteHandler && 'upvote-disabled'}`}
            onClick={(event) => clickHandler(event)}
            id={`upvote-tooltip-${roadmap?._id?.$oid}`}
        >
            <div className="upvote-icon">
                <FontAwesomeIcon icon={faCaretUp} />
            </div>
            <div pill="true">{upvotes}</div>
            {
                hasUserUpvoted && (
                    <Tooltip
                        placement="top"
                        isOpen={showTooltip}
                        target={`upvote-tooltip-${roadmap?._id.$oid}`}
                        toggle={toggle}
                    >
                        You have upvoted this
                    </Tooltip>
                )
            }
        </div>
    );
};

export default UpvoteComponent;